"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base64url_1 = __importDefault(require("base64url"));
const did_resolver_1 = require("did-resolver");
const elem_lib_1 = require("./elem-lib");
const KeysService_1 = __importDefault(require("../KeysService"));
class ElemDidDocument {
    constructor(keysService) {
        this._signingKey = 'primary';
        this._keysService = keysService;
    }
    _buildDIDDocModel(seedHex, publicKeyPrimary = null, privateKeyPrimary = null, publicKeyRecovery = null, privateKeyRecovery = null) {
        const arePublicPrivateKeysDefined = publicKeyPrimary && privateKeyPrimary;
        if (!arePublicPrivateKeysDefined) {
            const { publicKey, privateKey } = KeysService_1.default.getPublicAndPrivateKeys(seedHex, 'elem');
            publicKeyPrimary = publicKey.toString('hex');
            privateKeyPrimary = privateKey.toString('hex');
        }
        const arePublicPrivateRecoveryKeysDefined = publicKeyRecovery && privateKeyRecovery;
        if (!arePublicPrivateRecoveryKeysDefined) {
            const { publicKey, privateKey } = KeysService_1.default.getAnchorTransactionPublicAndPrivateKeys(seedHex, 'elem');
            publicKeyRecovery = publicKey.toString('hex');
            privateKeyRecovery = privateKey.toString('hex');
        }
        const primaryKey = { publicKey: publicKeyPrimary, privateKey: privateKeyPrimary };
        const recoveryKey = { publicKey: publicKeyRecovery, privateKey: privateKeyRecovery };
        return Object.assign(Object.assign({}, elem_lib_1.op.getDidDocumentModel(primaryKey.publicKey, recoveryKey.publicKey)), { '@context': 'https://w3id.org/security/v2', authentication: [`#${this._signingKey}`], assertionMethod: [`#${this._signingKey}`] });
    }
    _getDid(seedHex) {
        const { publicKey, privateKey } = KeysService_1.default.getPublicAndPrivateKeys(seedHex, 'elem');
        const primaryKey = {
            publicKey: publicKey.toString('hex'),
            privateKey: privateKey.toString('hex'),
        };
        const didDocumentModel = this._buildDIDDocModel(seedHex, primaryKey.publicKey, primaryKey.privateKey);
        const createPayload = elem_lib_1.op.getCreatePayload(didDocumentModel, primaryKey);
        const didUniqueSuffix = elem_lib_1.func.getDidUniqueSuffix(createPayload);
        const baseElemDID = `did:elem:${didUniqueSuffix}`;
        return {
            did: `${baseElemDID};elem:initial-state=${base64url_1.default.encode(JSON.stringify(createPayload))}`,
            shortFormDid: baseElemDID,
            didDocModel: didDocumentModel,
        };
    }
    _getMyDidConfig() {
        const { seed } = this._keysService.decryptSeed();
        const seedHex = seed.toString('hex');
        return this._getDid(seedHex);
    }
    getMyDid() {
        const { did } = this._getMyDidConfig();
        return did;
    }
    getKeyId(did = null) {
        if (!did) {
            const { shortFormDid } = this._getMyDidConfig();
            did = shortFormDid;
        }
        return `${did}#${this._signingKey}`;
    }
    buildDidDocument() {
        return __awaiter(this, void 0, void 0, function* () {
            const { seed } = this._keysService.decryptSeed();
            const seedHex = seed.toString('hex');
            const { did, didDocModel } = this._getDid(seedHex);
            const { did: parsedDid } = did_resolver_1.parse(did);
            const prependBaseDID = (field) => {
                if (typeof field === 'string') {
                    if (field.startsWith('#')) {
                        return `${parsedDid}${field}`;
                    }
                    else {
                        return field;
                    }
                }
                else if (typeof field === 'object' && 'id' in field && typeof field.id === 'string') {
                    if (field.id.startsWith('#')) {
                        return Object.assign(Object.assign({}, field), { id: `${parsedDid}${field.id}` });
                    }
                    else {
                        return field;
                    }
                }
                else {
                    throw new Error('Unsupported method format');
                }
            };
            return Object.assign(Object.assign({ id: parsedDid }, didDocModel), { publicKey: (didDocModel.publicKey || []).map(prependBaseDID), assertionMethod: (didDocModel.assertionMethod || []).map(prependBaseDID), authentication: (didDocModel.authentication || []).map(prependBaseDID) });
        });
    }
}
exports.default = ElemDidDocument;
//# sourceMappingURL=ElemDidDocument.js.map